import { TrackingEvent } from '../../../Entities/Schema.entity';

import { hovStartSchema } from './HovStartSchema';

export const hovStartToEvent = (): TrackingEvent<Record<any, any>> => {
  const event: TrackingEvent<Record<any, any>> = {
    schema: hovStartSchema.ref,
    data: {},
  };

  return event;
};
